/** The card form's address (2.M deliverable 11): `/sheets/cards/<docId>`, `?compare=1` from s3. */
export function cardFormHref(docId: string, options: { readonly compare?: boolean } = {}): string {
  return `/sheets/cards/${docId}${options.compare ? '?compare=1' : ''}`;
}

/** The search of `/sheets/cards/$docId`: `compare` (`1`) is kept, anything else dropped. */
export function validateCardSearch(search: Record<string, unknown>): { readonly compare?: 1 } {
  return search.compare === 1 || search.compare === '1' ? { compare: 1 } : {};
}
